import { Locality } from '@admin/shared/models/locality.model';
import { Serializable } from '@admin/core/models/serializable';

export class SubscriberLocalitySubscriptionModel
  implements Serializable<SubscriberLocalitySubscriptionModel>
{
  fromObject(obj: any): SubscriberLocalitySubscriptionModel {
    Object.assign(this, obj);
    this.locality = null;

    if (obj.locality != null) {
      let t = new Locality();
      t = t.fromObject(obj.locality);
      this.locality = t;
    }

    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public subscriberOccupationCategoryId: number;
  public subscriberId: number;
  public locality: Locality;

  constructor() {
    this.locality = new Locality();
  }
}
